import { render, staticRenderFns } from "./DataTable-Superadmin.vue?vue&type=template&id=4b11b872"
import script from "./DataTable-Superadmin.vue?vue&type=script&lang=js"
export * from "./DataTable-Superadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports